// DAS-2107: Standalone button for Portfolio Analysis view
// Renders a NavButton that opens the PortfolioAnalysisView in a full-width MUI Dialog.

import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Dialog, DialogTitle, DialogContent, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import InsightsIcon from '@mui/icons-material/Insights';
import NavButton from './ui/NavButton';
import PortfolioAnalysisView from './PortfolioAnalysisView';

const PortfolioAnalysisButton = ({ disabled = false }) => {
  const [open, setOpen] = useState(false);
  const portfolioData = useSelector(state => state.portfolio?.data?.portfolio || []);
  const reduxData = useSelector(state => state.portfolio?.data);
  const fixedIncomeData = {
    total: reduxData?.portfolio_topline?.[0]?.fixed_income_potential ?? null,
    distribution: reduxData?.fixed_return_components_over_asset_distribution?.distribution ?? null,
  };

  return (
    <>
      <NavButton
        icon={<InsightsIcon sx={{ fontSize: 14 }} />}
        label="Portfolio Analysis"
        onClick={() => setOpen(true)}
        disabled={disabled || portfolioData.length === 0}
        tooltip="Comprehensive portfolio analysis with live prices"
      />

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="xl"
        fullWidth
        PaperProps={{ sx: { minHeight: '80vh' } }}
      >
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pr: 2 }}>
          <Box display="flex" alignItems="center" gap={1}>
            <InsightsIcon color="primary" />
            Portfolio Analysis
          </Box>
          <IconButton onClick={() => setOpen(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {open && <PortfolioAnalysisView data={portfolioData} fixedIncomeData={fixedIncomeData} />}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default PortfolioAnalysisButton;
